/* eslint-disable no-console */
import { FormControl, Input } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';

export const PointerConfigEditor = ({
  availableFields: _unused,
  value,
  onChange,
}: {
  availableFields: CreditAgreement.Config.ConcentrationLimit.Calculation.AvailableField[];
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.PointerMethodCalculationConfig;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.PointerMethodCalculationConfig,
  ) => void;
}) => {
  console.log(onChange, value);
  return (
    <FormControl mb={4}>
      {/* makarand-temp: use shared component that has small mb */}
      <ConcentrationCalcFieldLabel
        m={1}
        label="Method"
        tooltip="The method used to calculate the concentration limit. This is configured by Finley Engineers."
      />
      <Input
        value={value.config.method}
        placeholder="pointer_method"
        onChange={(e) =>
          onChange({
            ...value,
            config: {
              ...value.config,
              method: e.target.value,
            },
          })
        }
      />
    </FormControl>
  );
};
